import { gql } from "@apollo/client";

export const GET_STRIPE_EPHMERAL_KEY = gql`
  query getStripeEphemeralKey($version: String!) {
    getStripeEphemeralKey(version: $version)
  }
`;
